import { useState, useCallback } from 'react';

const useConfirmation = () => {
  const [confirmationState, setConfirmationState] = useState({
    open: false,
    title: '',
    message: '',
    onConfirm: null,
    onCancel: null,
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    severity: 'warning',
    icon: null
  });

  const showConfirmation = useCallback(({
    title = 'Confirm Action',
    message = 'Are you sure you want to proceed?',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    severity = 'warning',
    icon = null,
    onConfirm = () => {},
    onCancel = () => {}
  }) => {
    setConfirmationState({
      open: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmationState(prev => ({ ...prev, open: false }));
      },
      onCancel: () => {
        onCancel();
        setConfirmationState(prev => ({ ...prev, open: false }));
      },
      confirmText,
      cancelText,
      severity,
      icon
    });
  }, []);

  const hideConfirmation = useCallback(() => {
    setConfirmationState(prev => ({ ...prev, open: false }));
  }, []);

  return {
    confirmationState,
    showConfirmation,
    hideConfirmation
  };
};

export default useConfirmation;
